import { NavBar } from '@/components/ui/tubelight-navbar';
import { Language } from '@growdash/cms-client/generated';
import { motion } from 'framer-motion';
import { BookOpen, Brain, FileText, Home, Phone } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface AppNavBarProps {
  languages: Language[];
}

export function AppNavBar({ languages }: AppNavBarProps) {
  const { t } = useTranslation();
  const navItems = [
    { name: t('navbar.home'), url: '/', icon: Home },
    { name: t('navbar.about'), url: '/about', icon: FileText },
    { name: t('navbar.growintel'), url: '/growintel', icon: Brain },
    { name: t('navbar.aisha'), url: '/aisha', icon: Brain },
    { name: t('navbar.blog'), url: '/blog', icon: BookOpen },
    { name: t('navbar.contact'), url: '/contact', icon: Phone }
  ];

  // Map languages to the expected shape: { code, name }
  const mappedLanguages = languages.map(lang => ({
    code: lang.key,
    name: lang.name
  }));

  return (
    <motion.div
      className='relative'
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.35, ease: 'easeOut' }}
    >
      <NavBar items={navItems} languages={mappedLanguages} />
    </motion.div>
  );
}
